import React from "react";
import Paper from "@material-ui/core/Paper";
import {paper_style} from "./styles";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import BackButton from "./Buttons/BackButton"


class AboutUs extends React.Component{


    render() {
        return(
            <Container component="main" maxWidth="xs">
            <Paper style={paper_style}>
            <BackButton ></BackButton>
            <div>
    בייביסיטר מיוחד במינו בשיתוף "עדי בשבילכם" מציע חיבור בין הורים לילדים מיוחדים לבייביסיטרים פוטנציאלים מתחום החינוך המיוחד. החיבור יכול להיעשות במספר דברים, מעבר לחיבור דרך האפליקציה הנוכחית ישנן קבוצות וואטסאפ על פי איזורים בארץ וקבוצת פייסבוק ארצית. בקבוצות המשתתפים הורים לילדים מיוחדים ובייביסיטרים מהתחום. התשלום נקבע על פי תשלום מראש בין ההורה לבייביסיטר.
    </div>
    <Box m={0.5} />
    <div align = "right">
    <div>
    את הפרויקט הקימה הגב' נעמי אבנר- אמא לילד עם פגיעה מוחית קשה אשר ראתה את הצורך בביביסיטר להורים לילדים מיוחדים ורתמה סטודנטיות לחינוך מיוחד לפיתוח והפעלת הפרויקט. מטרת הפרויקט היא להרחיב את מאגר הבייביסיטרי וכך לאפשר למספר מירבי של הורים לילדים מיוחדים רווחה ומרווח נפשי ולהשקיע בעצמם בזמן שהם יודעים שילדיהם בידיים טובות.
    </div>
    <Box m={0.5} />
    <div>
    אנחנו כאן לכל שאלה, בקשה ועזרה. מוזמנים לפנות אלינו בהודעת וואטסאפ למספר 0556876741 או במייל bbmeyuchad@gmail.com.
    </div>
    <Box m={0.5} />
    <div>
    בברכה,
    </div>
    <Box m={0.5} />
    <div>
    צוות בייביסיטר מיוחד במינו בשיתוף עדי בשבילכם
    </div>
    <Box m={1} />
    <div>
    <Box fontWeight="fontWeightBold" m={0}>
    תנאי שימוש
    </Box>
    </div>
    <Box m={0.5} />
    <div>
    בייביסיטר מיוחד במינו מהווה פלטמורפמה בלבד למציאת בייביסיטר מתאים לצרכים המיוחדים שלכם. הצוות המנהל מסיר כל אחריות על איכות הבייביסיטר וכנ"ל על המשפחה הפונה. טיב הקשר בין המשפחה הפונה לבייביסטר על דעתם בלבד.
    </div>
    </div>
    </Paper>
    </Container>
        )
    }
}

export default AboutUs

